import validate from "/home/boristane/boristane/zirp/node_modules/.pnpm/nuxt@3.13.2_@biomejs+biome@1.9.4_@parcel+watcher@2.4.1_@types+node@20.14.2_eslint@9.11.1_jiti_mk34axq4lpi2m2kplkyyqfslby/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/boristane/boristane/zirp/node_modules/.pnpm/nuxt@3.13.2_@biomejs+biome@1.9.4_@parcel+watcher@2.4.1_@types+node@20.14.2_eslint@9.11.1_jiti_mk34axq4lpi2m2kplkyyqfslby/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/boristane/boristane/zirp/apps/web/app/middleware/auth.ts")
}